export { AffiliatePage } from "./AffiliatePage";
export { ErrorPage } from "./ErrorPage";
export { NewsletterPage } from "./NewsletterPage";
export { LandingPage } from "./LandingPage";
export { WidgetPage } from "./WidgetPage";
export { CustomPage } from "./CustomPage";
